<div class="callout" *ngIf="showChecklist">
  <i class="callout__close glyphicon glyphicon-times" (click)="close()"></i>

  <div class="callout__header">
    <h1 class="callout__title">Get the most out of Airbrake</h1>
    <div class="progress-wrap">
      <ngb-progressbar
        class="progress"
        type="success"
        [max]="checklistCount()"
        [value]="completedCount()"
      ></ngb-progressbar>
      <div>&nbsp;{{ completedCount() }} of {{ checklistCount() }}</div>
    </div>
  </div>

  <div class="callout__body">
    <ul class="pl-3">
      <li
        *ngFor="let task of tasks(); trackBy: trackByIndex"
        class="task"
        [ngSwitch]="task.class_name"
        [ngClass]="{ 'task--completed': task.state === 'complete' }"
      >
        <a
          class="task__anchor"
          *ngSwitchCase="'AddApm'"
          uiSref="project-performance"
        >
          <i
            class="task__icon ab-icon-check"
            *ngIf="task.state === 'complete'"
          ></i
          >Start tracking application performance
        </a>

        <a
          class="task__anchor"
          *ngSwitchCase="'AddDeploys'"
          uiSref="project-deploys"
        >
          <i
            class="task__icon ab-icon-check"
            *ngIf="task.state === 'complete'"
          ></i
          >Start tracking deploys
        </a>

        <a
          class="task__anchor"
          *ngSwitchCase="'AddSlack'"
          href="/projects/{{ project.id }}/services/12"
          target="_self"
        >
          <i
            class="task__icon ab-icon-check"
            *ngIf="task.state === 'complete'"
          ></i
          >Add Slack workspace
        </a>

        <a
          class="task__anchor"
          *ngSwitchCase="'CreateProject'"
          href="/users/{{ user.id }}/edit?project_modal=1"
          target="_self"
        >
          <i
            class="task__icon ab-icon-check"
            *ngIf="task.state === 'complete'"
          ></i
          >Create a project
        </a>

        <a
          class="task__anchor"
          *ngSwitchCase="'NameFirstProject'"
          href="/projects/{{ project.id }}/edit"
          target="_self"
        >
          <i
            class="task__icon ab-icon-check"
            *ngIf="task.state === 'complete'"
          ></i
          >Name first project
        </a>
      </li>
    </ul>
  </div>
</div>
<div class="callout__backdrop" *ngIf="showChecklist" (click)="close()"></div>
